import React from 'react';
import Utilities from '@util/Utilities';
import { useFieldContext } from '@app/site/_form';
import { FieldErrors } from '@app/site/_form/field/FieldErrors';


type TextAreaFieldProps = {
	placeholder?: string,
	label?: string,
	isLoading?: boolean,
	disabled?: boolean,
	extraClassName?: string,
	labelHint?: string,
	maxLength?: number,
	hideErrorMessage?: boolean,
	rows?: number,
	cols?: number,
	resize?: 'none' | 'both' | 'horizontal' | 'vertical'
}

export const TextAreaField: React.FunctionComponent<TextAreaFieldProps> = (props) => {
	const field = useFieldContext<string>();

	const hasError = field.state.meta.isTouched && !field.state.meta.isValid;

	const renderField = () => {
		return <textarea
			className={Utilities.classNames(
				"input",
				Utilities.NVL(hasError, 'input-error'),
				Utilities.NVL(props.isLoading, 'input-isLoading'),
				Utilities.NVL(props.disabled, 'input-disabled'),
				Utilities.NVL(!!props.extraClassName, props.extraClassName!),
			)}
			disabled={props.disabled}
			maxLength={props.maxLength}
			placeholder={props.placeholder}
			value={field.state.value}
			rows={props.rows || 4}
			cols={props.cols}
			style={{ resize: props.resize || 'vertical' }}
			onChange={(e) => field.handleChange(e.target.value)} />;
	};

	return !!props.label ? <div>
		<div className="flex">
			<div className="label">{props.label}</div>
			{!!props.labelHint ? <span className="text-xs leading-6 text-gray-500 ml-2 italic">{props.labelHint}</span> : ''}
		</div>
		<div className="mt-0.5">
			{renderField()}
		</div>
		{!props.hideErrorMessage && <FieldErrors meta={field.state.meta} />}
	</div>: renderField();
};
